import React from 'react';
export function CTAButton() {
  return <button className="bg-purple-700 hover:bg-purple-800 text-white font-bold py-4 px-8 rounded-full text-xl shadow-lg transform transition-transform hover:scale-105 w-full md:w-auto" onClick={() => window.location.href = 'https://snoutyco.com/products/the-daily-foundation-chew'} data-id="element-279">
      ORDER NOW - SAVE 20% ON YOUR FIRST PURCHASE
    </button>;
}